/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, Fragment, useState } from "react";
import Breadcrumb from "../DefaultComponent/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import { Pagination, Stack, Button } from "@mui/material";
import { formatDate, calculateTotalPages } from "../../utils/Helper";
import Spinner from "../DefaultComponent/Spinner";
import ToastDefault from "../DefaultComponent/Toast";
import SelectOption from "../DefaultComponent/FilterHelper/SelectOption";
import SearchInput from "../DefaultComponent/FilterHelper/SelectInput";
import { UsersList } from "../../Redux/Actions/OrganizationAction";
import { userFilterOption } from "../../utils/Json";
import { StyledToggleButtonGroup } from "../DefaultComponent/FilterHelper/Tooglebutton";
import ToggleButton from "@mui/material/ToggleButton";
import { useNavigate } from "react-router-dom";
import { BREW_USER_STORAGE_KEY } from "../../Config/Config";

const Users = () => {
  const dispatch = useDispatch<any>();
  const [count, setcount]: any = useState(0);
  const [usersDetails, setuserDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(12);
  const [select, setSelect] = useState<string>("Search By");
  const [search, setSearch] = useState<string>("");
  const [alignment, setAlignment] = React.useState("all");
  const UsersData = useSelector((state: any) => state.UsersListData);
  const navigate = useNavigate();

  const fetchUsers = (params: any) => {
    setLoading(true);
    dispatch(UsersList(params));
    setLoading(false);
  };
  useEffect(() => {
    const params = `?page=${page}&page_size=${rowsPerPage}${
      select !== "Search By" && search.trim() !== ""
        ? `&${select}=${search}`
        : ""
    }`;
    fetchUsers(params);
  }, [dispatch, page, rowsPerPage, search, select]);

  useEffect(() => {
    if (UsersData?.data?.row) {
      setuserDetails(() => UsersData?.data?.row);
      setcount(() => UsersData?.data?.total_count);
    }
  }, [UsersData]);

  const handleUserOpen = (user: any) => {
    sessionStorage.setItem(BREW_USER_STORAGE_KEY, JSON.stringify(user));
    navigate(`/brew-users/${user?.id}`, {
      state: {
        user,
      },
    });
  };

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    setAlignment(newAlignment);
    setPage(1);
    let params;
    if (newAlignment === "all") {
      params = `?page=${page}&page_size=${rowsPerPage}`;
    } else if (newAlignment === "is_staff") {
      params = `?page=${page}&page_size=${rowsPerPage}&is_staff=True`;
    } else if (newAlignment === "is_active") {
      params = `?page=${page}&page_size=${rowsPerPage}&is_active=True`;
    }

    fetchUsers(params);
  };

  return (
    <>
      {loading && <Spinner />}
      <div
        className="page-wrapper card"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="col-md-12">
          <Breadcrumb
            pageTitle="Users"
            breadcrumbs={[
              {
                label: "Users",
                path: "/brew-users",
                isActive: true,
              },
            ]}
          />
        </div>

        <div className="row m-2 mt-4 mb-0">
          <div className="col-md-12 filter-bar">
            <div className="d-flex justify-content-between">
              <div className="col-md-3 user-status-option">
                <StyledToggleButtonGroup
                  color="primary"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                  aria-label="Platform"
                >
                  <ToggleButton value="all">All</ToggleButton>
                  <ToggleButton value="is_staff">Org's Users</ToggleButton>
                  <ToggleButton value="is_active">Active Users</ToggleButton>
                </StyledToggleButtonGroup>
              </div>

              <div className="col-md-6 search-bar">
                <SelectOption
                  option={userFilterOption}
                  select={select}
                  setPage={setPage}
                  setSelect={setSelect}
                />
                <SearchInput
                  placeholder={`Search`}
                  setPage={setPage}
                  searchText={search}
                  setSearchText={setSearch}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="row"
          style={{ width: "100%", display: "flex", flexWrap: "nowrap" }}
        >
          <div className={`m-2 table-full-container"}`} style={{ flex: 1 }}>
            <div className="card">
              <div className="table-responsive">
                <table className="table">
                  <thead className="table-dark">
                    <tr>
                      <th scope="col">S.No</th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Registered Date</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usersDetails?.length > 0
                      ? usersDetails?.map((user: any, userskey: any) => {
                          return (
                            <Fragment key={userskey}>
                              <tr
                                className="table-row-clickable"
                                onClick={() => handleUserOpen(user)}
                              >
                                <th scope="row">
                                  {(page - 1) * rowsPerPage + userskey + 1}
                                </th>
                                <td>{user?.fullname}</td>
                                <td>{user?.email}</td>
                                <td>{formatDate(user?.date_joined)}</td>
                                <td>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      handleUserOpen(user);
                                    }}
                                  >
                                    View Details
                                  </Button>
                                </td>
                              </tr>
                            </Fragment>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="pagination-style">
              <Stack spacing={2}>
                <Pagination
                  count={calculateTotalPages(count, rowsPerPage)}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                  page={page}
                  onChange={(e: any, newPage) => setPage(newPage)}
                />
              </Stack>
            </div>
          </div>
        </div>
      </div>
      <ToastDefault />
    </>
  );
};

export default Users;
